import FullscreenOverlay from './FullscreenOverlay';
import WistiaVideoPlayer from './WistiaVideoPlayer';
import { trackEvent } from 'common/utils/analytics';

const INLINE_VIDEO_PLAYER_ID = 'wistia_video_frontpage_hero_inline';
const OVERLAY_VIDEO_PLAYER_ID = 'wistia_video_frontpage_hero_overlay';
const OVERLAY_SELECTOR = '[data-video-hero-overlay]';
const POST_ROLL_SELECTOR = '[data-overlay-hero-video-post-roll]';
const OVERLAY_VIDEO_TRIGGER_SELECTOR = '[data-overlay-hero-video-trigger]';
const OVERLAY_VIDEO_CONTAINER_SELECTOR = '[data-overlay-hero-video-container]';
const INLINE_VIDEO_TRIGGER_SELECTOR = '[data-inline-video-player-trigger]';
const INLINE_VIDEO_CONTAINER_SELECTOR = '[data-hero-video-inline-player-container]';
const INLINE_VIDEO_ACTIVE_WATCHER_SELECTOR = '[data-hero-video-inline-player-status-watcher]';

export default class VideoHero {
    constructor(element) {
        this.element = element;

        this.inlinePlayer = this._setupInlinePlayer();
        this.overlayPlayer = this._setupOverlayPlayer();
        this.overlay = this._setupOverlay();

        this.element.querySelector(OVERLAY_VIDEO_TRIGGER_SELECTOR)
            .addEventListener('click', () => this._showOverlayPlayer());
    }

    _setupOverlay() {
        return new FullscreenOverlay({
            element: this.element.querySelector(OVERLAY_SELECTOR),
            options: {
                onOpen: () => {
                    this.overlayPlayer.play();
                    trackEvent('Started Homepage Hero Video', {
                        position: 'overlay',
                    });
                },
                onClose: () => {
                    this.overlayPlayer.pause();
                    this._showOverlayPlayer();
                },
            }
        });
    }

    _setupOverlayPlayer() {
        return new WistiaVideoPlayer({
            id: OVERLAY_VIDEO_PLAYER_ID,
            triggers: [this.element.querySelector(OVERLAY_VIDEO_TRIGGER_SELECTOR)],
            options: {
                onEnd: () => this._attemptToShowPostRollContent(),
                onFullscreenLeave: () => this._handleFullscreenLeave(),
            }
        });
    }

    _setupInlinePlayer() {
        const activeWatchers = this.element.querySelectorAll(INLINE_VIDEO_ACTIVE_WATCHER_SELECTOR);

        return new WistiaVideoPlayer({
            id: INLINE_VIDEO_PLAYER_ID,
            triggers: this.element.querySelectorAll(INLINE_VIDEO_TRIGGER_SELECTOR),
            options: {
                onPlay: () => {
                    for (let watcher of activeWatchers) {
                        watcher.setAttribute('data-wistia-player-active', true);
                    }

                    trackEvent('Started Homepage Hero Video', {
                        position: 'inline',
                    });
                },
                onPause: () => {
                    for (let watcher of activeWatchers) {
                        watcher.removeAttribute('data-wistia-player-active');
                    }
                },
                onReady: () => {
                    this.element.querySelector(INLINE_VIDEO_CONTAINER_SELECTOR)
                        .setAttribute('data-wistia-player-ready', true);
                },
            }
        });
    }

    _showOverlayPlayer() {
        this.element.querySelector(OVERLAY_VIDEO_CONTAINER_SELECTOR)
            .removeAttribute('data-hidden');
        this.element.querySelector(POST_ROLL_SELECTOR)
            .setAttribute('data-hidden', '');
    }

    _handleFullscreenLeave() {
        if (this.overlayPlayer.state() === 'ended') {
            this._attemptToShowPostRollContent();
        }
    }

    _attemptToShowPostRollContent() {

        // Don't show post-roll content if fullscreen is active due to browser
        // issues hiding the player while in fullscreen mode
        if (!this.overlayPlayer.isFullscreen) {
            this._showPostRollContent();
        }
    }

    _showPostRollContent() {
        this.element.querySelector(POST_ROLL_SELECTOR)
            .removeAttribute('data-hidden');
        this.element.querySelector(OVERLAY_VIDEO_CONTAINER_SELECTOR)
            .setAttribute('data-hidden', '');
    }

    static create(selector='[data-video-hero]') {
        const hero = document.querySelector(selector);

        if (hero) {
            new VideoHero(hero);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./js/marketing/components/VideoHero.js
 **/